<template>
  <b-taginput
    field="name"
    name="administrations"
    icon="caret-right"
    :data="filteredAdministrations"
    :allow-new="true"
    v-validate="'required'"
    rounded
    v-model="buffer"
    :placeholder="$t('compCoreAdministrationInput.label')"
    :open-on-focus="true"
    @typing="getFilteredAdministrations"
    @input="$emit('input', buffer)"
    autocomplete
  >
    <template slot-scope="props">
      {{ props.option.name }}
    </template>
  </b-taginput>
</template>

<script>
import coreService from '@/services/coreService'

export default {
  name: 'AdministrationInput',
  inject: ['$validator'],
  props: {
    value: Array
  },
  data () {
    return {
      administrations: [],
      filteredAdministrations: [],
      buffer: Object.assign([], this.value)
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = Object.assign([], this.value)
      },
      deep: true
    }
  },
  methods: {
    getFilteredAdministrations (text) {
      this.filteredAdministrations = this.administrations.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        )
      })
    }
  },
  created () {
    coreService.getAdministrations().then((data) => {
      this.administrations = data
      this.filteredAdministrations = data
    })
  }
}
</script>
